import { render, staticRenderFns } from "./QueryCourse.vue?vue&type=template&id=49a153b6&scoped=true"
import script from "./QueryCourse.vue?vue&type=script&lang=js"
export * from "./QueryCourse.vue?vue&type=script&lang=js"
import style0 from "./QueryCourse.vue?vue&type=style&index=0&id=49a153b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a153b6",
  null
  
)

export default component.exports